import { QuerySegment } from "./QuerySegment";

export class QueryLeafNode extends QuerySegment {
  field?: string;
  fields?: string[];

  value?: string | number | boolean | null | undefined;
  values?: (string | number | boolean | null | undefined)[];

  label?: string;
  labels?: string[];

  // Lower, Upper, and Comparison are used for range operators only.
  lower?: string | number | boolean | null | undefined;
  upper?: string | number | boolean | null | undefined;
  // Abbreviations of Greater-Than (gt), Greater-Than-or-Equal (gte), Less Than (lt), Less-Than-or-Equal (lte), controlling the operation used for the range.
  // Allowed values: gt_lt, gte_lt, gt_lte, gte_lte, Default: gte_lte
  comparison?: string;

  constructor(queryLeafNode: any) {
    super(queryLeafNode);
    this.fromJSON(queryLeafNode);
    return this;
  }

  fromJSON(queryLeafNode: any) {
    this.op = queryLeafNode?.op;
    this.field = queryLeafNode?.field;
    this.fields = queryLeafNode?.fields;
    this.value = queryLeafNode?.value;
    this.values = queryLeafNode?.values;
    this.label = queryLeafNode?.label;
    this.labels = queryLeafNode?.labels;

    this.lower = queryLeafNode?.lower;
    this.upper = queryLeafNode?.upper;
    this.comparison = queryLeafNode?.comparison;
  }

  resetToDefaults() {
    this.field = undefined;
    this.fields = undefined;
    this.value = undefined;
    this.values = undefined;
    this.label = undefined;
    this.labels = undefined;
    this.lower = undefined;
    this.upper = undefined;
    this.comparison = undefined;
  }

  toAPIQuery() {
    const queryObj:any = {
      op: this.op
    }

    if (this.field) { queryObj.field = this.field; }
    if (this.fields) { queryObj.fields = this.fields; }
    if (this.value !== undefined) { queryObj.value = this.value; }
    if (this.values) { queryObj.values = this.values; }
    if (this.label) { queryObj.label = this.label; }
    if (this.labels) { queryObj.labels = this.labels; }
    if (this.lower !== undefined) { queryObj.lower = this.lower; }
    if (this.upper !== undefined) { queryObj.upper = this.upper; }
    if (this.comparison) { queryObj.comparison = this.comparison; }

    return queryObj;
  }
}